import * as React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Suspense } from "react";
import { Routes } from "../constants";
import Settings from "../components/settings/settings";
import Home from "../components/home/home";
import PainelAtendimento from "../components/painel-atendimento/painel-atendimento";
import PainelAtendimentoEquipe from "../components/painel-atendimento/painel-atendimento-equipe";
import ConfigTab from "../components/config/config-tab";
import Agendamento from "../components/agendamento/agendamento";
import MeetingsDataPage from "../components/meetings/meetings";
import MeetingQueue from "../components/meeting-queue/meeting-queue";
import MeetingQueueAuth from "../components/meeting-queue-auth/meeting-queue-auth";
import { LoginRedirect } from "../components/login-redirect/login-redirect";
import AvisoForaHorario from "../components/meeting-queue/queue-cards/aviso-fora-horario/aviso-fora-horario";
import AvisoIndisponivel from "../components/meeting-queue/queue-cards/aviso-indisponivel/aviso-indisponivel";
import AccessDisabled from "../components/meeting-queue/queue-cards/access-disabled/access-disabled";
import QueueLimit from "../components/meeting-queue/queue-cards/queue-limit/queue-limit";
import ServiceUnit from "../components/home/unidade/unidade";
import { MeetingExtensibilityConfiguration } from "../components/meeting-extensibility/config";
import InMeetingPanel from "../components/meeting-extensibility/in-meeting-panel/in-meeting-panel";
import InMeetingAlert from "../components/meeting-extensibility/in-meeting-panel/in-meeting-alert";
import PostMeetingPanel from "../components/meeting-extensibility/post-meeting-panel/post-meeting-panel";
import Acs from "../components/acs/acs";
import Error from "../components/error/error";
import SignInPage from "../components/signin/signin";
import SignInSimpleStart from "../components/signin/signin-start";
import SignInSimpleEnd from "../components/signin/signin-end";
import Dashboards from "../components/dashboards/dashboards";

export const AppRoute: React.FunctionComponent<{}> = () => {
    return (
        <Suspense fallback={<div></div>}>
            <BrowserRouter>
                <Switch>
                    <Route exact path={Routes.teamsApp.listServentias} component={Home} />
                    <Route exact path={Routes.teamsApp.painelAtendimento} component={PainelAtendimento} />
                    <Route exact path={`${Routes.teamsApp.painelAtendimento}/:id/:title`} component={PainelAtendimento} />
                    <Route exact path={Routes.teamsApp.painelAtendimentoEquipe} component={PainelAtendimentoEquipe} />
                    <Route exact path={`${Routes.teamsApp.painelAtendimentoEquipe}/:id/:title`} component={PainelAtendimentoEquipe} />
                    <Route path={Routes.teamsApp.configTab} component={ConfigTab} />
                    <Route exact path={Routes.teamsApp.agendamento} component={Agendamento} />
                    <Route exact path={Routes.teamsApp.formBalcaoVirtual} component={ServiceUnit} />
                    <Route exact path={`${Routes.teamsApp.formBalcaoVirtual}/:id`} component={ServiceUnit} />
                    <Route exact path={Routes.teamsApp.settings} component={Settings} />
                    <Route exact path={`${Routes.teamsApp.settings}/:id`} component={Settings} />
                    <Route exact path={`${Routes.teamsApp.settings}/:id/:appId`} component={Settings} />
                    <Route exact path={Routes.teamsApp.configMeetingExtensibility} component={MeetingExtensibilityConfiguration} />
                    <Route exact path={Routes.teamsApp.inMeetingPanel} component={InMeetingPanel} />
                    <Route exact path={Routes.teamsApp.inMeetingAlert} component={InMeetingAlert} />
                    <Route exact path={Routes.teamsApp.postMeetingPanel} component={PostMeetingPanel} />
                    <Route exact path={`${Routes.teamsApp.postMeetingPanel}/:id/:ancora`} component={PostMeetingPanel} />
                    <Route exact path={Routes.teamsApp.errorPage} component={Error} />
                    <Route exact path={`${Routes.teamsApp.errorPage}/:message`} component={Error} />
                    <Route exact path={Routes.teamsApp.signin} component={SignInPage} />
                    <Route exact path={Routes.teamsApp.signinSimpleStart} component={SignInSimpleStart} />
                    <Route exact path={Routes.teamsApp.signinSimpleEnd} component={SignInSimpleEnd} />
                    <Route exact path={Routes.teamsApp.dashboards} component={Dashboards} />
                </Switch>
            </BrowserRouter>
        </Suspense>
    );
};

export const AppAnonymousRoute: React.FunctionComponent<{}> = () => {
    return (
        <Suspense fallback={<div></div>}>
            <BrowserRouter>
                <Switch>
                    <Route exact path={Routes.publicApp.root} component={MeetingsDataPage} />
                    <Route path={Routes.publicApp.meetingQueue} component={MeetingQueue} />
                    <Route path={Routes.publicApp.meetingQueueAuth} component={MeetingQueueAuth} />
                    <Route path={Routes.publicApp.acs} component={Acs} />
                    <Route path={Routes.publicApp.loginRedirect} component={LoginRedirect} />
                    <Route path={Routes.publicApp.avisoForaHorario} component={AvisoForaHorario} />
                    <Route path={Routes.publicApp.avisoIndisponivel} component={AvisoIndisponivel} />
                    <Route path={Routes.publicApp.queueLimit} component={QueueLimit} />
                    <Route path={Routes.publicApp.accessDisabled} component={AccessDisabled} />
                    <Route path={Routes.publicApp.meetings} component={MeetingsDataPage} />
                    <Route exact path={Routes.publicApp.errorPage} component={Error} />
                </Switch>
            </BrowserRouter>
        </Suspense>
    );
};